export const RentbackActionTypes = {
    API_RESPONSE_SUCCESS: '@@rentback/API_RESPONSE_SUCCESS',
    API_RESPONSE_ERROR: '@@rentback/API_RESPONSE_ERROR',
    GET_RENTBACK: '@@rentback/GET_RENTBACK',
    SUBMIT_RENTBACK: '@@rentback/SUBMIT_RENTBACK',
    CONFIRM_RENTBACK: '@@rentback/CONFIRM_RENTBACK',
    RETRACT_RENTBACK: '@@rentback/RETRACT_RENTBACK',
    RESET_RENTBACK: '@@rentback/RESET_RENTBACK',
};
